/* eslint-disable no-underscore-dangle */
import React, { FC, useEffect } from 'react';
import dynamic from 'next/dynamic';
import { styled } from 'linaria/react';
import parse from 'date-fns/parse';
import { useRouter } from 'next/router';
import { authHelper } from '@entities/user';
import { getReceiptData } from '@shared/lib/receipt';
import { paymentFailGtm, paymentMethods, paymentProcessingGtm, paymentSuccessGtm } from '@shared/lib/gtm/redesign';
import { getFormatDate } from '@shared/lib/date';
import { Partners, usePartner } from '@shared/lib/partner';
import { withTheme } from '@shared/lib/theme';
import { OperationDetailsRs } from '@root/api/ump-ewallet';
import PaymentStatusInfo from './PaymentStatusInfo';
import { useOperationDetails } from '../model/useOperationDetails';
import FailedToDisplay from './FailedToDisplay';
const DynamicAnimatedBackground = dynamic(() => import('@shared/ui/organisms').then(imported => imported.AnimatedBackground), {
  ssr: false
});
export interface OperationDetailsProps {
  error3ds?: OperationDetailsRs;
}
const OperationDetails: FC<OperationDetailsProps> = ({
  error3ds
}) => {
  const {
    fullUserInfo
  } = authHelper;
  const userId = fullUserInfo?.user_id;
  const router = useRouter();
  const {
    id
  } = router.query as {
    id: string;
  };
  const {
    partner
  } = usePartner();
  const {
    data: operationDetails
  } = useOperationDetails({
    userId: userId || '',
    mdOrder: id
  }, error3ds as OperationDetailsRs);
  const {
    service,
    date,
    mdOrder,
    state
  } = error3ds || operationDetails || {};
  const parsedDate = parse(date as string, 'dd/MM/yyyy HH:mm:ss', new Date());
  const formattedDate = getFormatDate(parsedDate);
  useEffect(() => {
    const eventKey = `gtmEvent_${mdOrder}`;
    const isEventFired = sessionStorage.getItem(eventKey);
    const resultParams = {
      productName: service?.serviceName || '',
      amount: String(operationDetails?.amount?.total || operationDetails?.amount?.base || ''),
      requestId: id,
      transactionId: mdOrder || id,
      paymentMethod: paymentMethods.mtsAccount
    };
    if (!isEventFired) {
      if (state === 2) {
        paymentSuccessGtm(resultParams);
        const isFromPubgGiveawayPage = router.query.from === 'rozygrysh-prizov-pubg-mobile';
        if (isFromPubgGiveawayPage) {
          window.recordTier?.push({
            eventName: 'purchase',
            tracking_id: '128636058'
          });
          window._tmr?.push({
            type: 'reachGoal',
            id: 3712315,
            goal: 'successful_payment'
          });
          window?.bge('event', 'ec_purchase', {
            configId: '906023989302433792'
          });
        }
        if (partner === Partners.DEFAULT) {
          window?._tmr?.push({
            type: 'reachGoal',
            id: 3712315,
            goal: 'successful_payment_games_cyber'
          });
        }
        sessionStorage.setItem(eventKey, 'success');
      }
      if (state === 6) {
        paymentFailGtm({
          ...resultParams,
          reason: operationDetails?.errorMessage
        });
        sessionStorage.setItem(eventKey, 'rejected');
      }
      if (state === 5 || state === 7) {
        paymentProcessingGtm(resultParams);
        sessionStorage.setItem(eventKey, 'waiting');
      }
    }
  }, [state, service?.serviceName, mdOrder]);
  const receiptData = getReceiptData({
    serviceName: service?.serviceName,
    id: mdOrder
  });
  return <ResultSbpPageViewWrapper>
      <NotScrollableContent>
        <DynamicAnimatedBackground />
      </NotScrollableContent>
      <ScrollableContentWrapper>
        {operationDetails?.errorCode === 308 ? <FailedToDisplay /> : <PaymentStatusInfo formattedDate={formattedDate} receiptData={receiptData} operationDetails={operationDetails} />}
      </ScrollableContentWrapper>
    </ResultSbpPageViewWrapper>;
};
export default OperationDetails;
const ResultSbpPageViewWrapper = /*#__PURE__*/styled('div')({
  name: "ResultSbpPageViewWrapper",
  class: "r1sslmh9",
  propsAsIs: false
});
const NotScrollableContent = /*#__PURE__*/styled('div')({
  name: "NotScrollableContent",
  class: "n1d78lwd",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.primary;
const ScrollableContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ScrollableContentWrapper",
  class: "stkcjay",
  propsAsIs: false,
  vars: {
    "stkcjay-0": [_exp()]
  }
}));

require("./OperationDetails.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./OperationDetails.tsx");